// extracted by mini-css-extract-plugin
export default {"major-box-grid":"MajorBoxGroup_major-box-grid__SbSw+"};